import * as braze from '@braze/web-sdk'
import Bugsnag from '@bugsnag/js'
import config from 'config'

export const useBraze = () => {
  const initializeBraze = () => {
    if (!config.brazeApiKey) {
      Bugsnag.leaveBreadcrumb('Braze API key is missing in the configuration.')
      return
    }

    try {
      braze.initialize(config.brazeApiKey, {
        baseUrl: 'https://horus.iad-03.braze.com/api/v3',
      })

      braze.automaticallyShowInAppMessages()

      braze.openSession()
    } catch (error) {
      Bugsnag.leaveBreadcrumb('Failed to initialize Braze')
    }
  }

  const changeBrazeUser = (userId: string) => {
    try {
      braze.changeUser(userId)
    } catch (error) {
      Bugsnag.leaveBreadcrumb('Failed to change Braze user')
    }
  }

  return { initializeBraze, changeBrazeUser }
}
